import {
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "~/lib";
import { SignUpFormValues } from "~/types";

const ADD_FIREBASE_TENANT_LOG = "[addFirebaseTenant]";

/**
 * Creates a Firebase Auth user (email/password sign-up).
 * DynamoDB + Firestore tenant profile are ensured by Lambda sign-in after auth.
 */
export const addFirebaseTenant = async (
  payload: SignUpFormValues,
  createUser: boolean
) => {
  if (!createUser) {
    return {
      success: false,
      error: "Auth user creation is required",
    };
  }

  try {
    const tenant = await createUserWithEmailAndPassword(
      auth,
      payload.email,
      payload.password
    );

    return {
      success: true,
      data: { id: tenant.user.uid },
    };
  } catch (error: unknown) {
    const err = error as { message?: string; code?: string };
    console.error(ADD_FIREBASE_TENANT_LOG, "failed", {
      code: err?.code,
      message: err?.message,
    });
    return {
      success: false,
      data: {},
      error: err?.message ?? "Sign up failed",
    };
  }
};
